import type { ReactElement, ReactNode } from "react";

import { Label } from "@/components/base/label/label";
import { cx } from "@/utils/cx";

export interface MarkerPopupAttributeRowProps {
	/** Caption above the value (Figma Label light / sm). */
	label: string;
	/** Primary value (Figma Label dark / md). */
	value: ReactNode;
	className?: string;
}

/**
 * Point-details caption + value stack — Figma MarkerPopup/_PointDetail/AttributeRow.
 */
export function MarkerPopupAttributeRow({
	label,
	value,
	className,
}: MarkerPopupAttributeRowProps): ReactElement {
	return (
		<div
			className={cx("flex min-w-0 flex-col items-start", className)}
			data-testid="marker-popup-attribute-row"
		>
			<Label size="sm" type="light" showIcon={false}>
				{label}
			</Label>
			<Label size="md" type="dark" showIcon={false} className="w-full">
				{value}
			</Label>
		</div>
	);
}
